import React, { useState, useEffect, useMemo } from "react";
import { useFormRender } from "../hooks/useFormRender";
import { Button } from "@mantine/core";
import { IconExclamationMark } from "@tabler/icons";

import { useServerApi } from "../hooks/userServerApi";
import { getAddFormSchema } from "../pages/operation/order";
import { showNotification } from "@mantine/notifications";
import _ from "lodash";
import { useTranslation } from "react-i18next";

const getOrderProviderId = (orderValues) => {
  if (!orderValues) return null;
  return (
    orderValues.provider?._id ??
    orderValues.provider ??
    orderValues.productSnapShot?.provider?._id ??
    orderValues.productSnapShot?.provider ??
    null
  );
};

const OrderAddRiderActionButton = ({ mainForm, label = "Add New Rider" }) => {
  const [basicPlanOrderId, setBasicPlanOrderId] = useState();
  const [riderTypeId, setRiderTypeId] = useState(null);
  const [api] = useServerApi();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchRiderType = async () => {
      const result = await api.search({
        apiEntity: "productType",
        searchQuery: { code: "RIDER" },
        pageSize: 1,
        byAggregation: false,
      });
      if (result?.docs?.[0]?._id) {
        setRiderTypeId(result.docs[0]._id);
      }
    };
    fetchRiderType();
  }, []);

  const providerId = getOrderProviderId(mainForm?.values);

  const formSchema = useMemo(() => {
    const schema = { ...getAddFormSchema(t) };
    schema.title = "Add New Rider";

    if (schema.layout?.fields && riderTypeId && providerId) {
      schema.layout = {
        ...schema.layout,
        fields: schema.layout.fields.map((field) =>
          field.name === "product"
            ? {
                ...field,
                props: {
                  ...field.props,
                  preQuery: {
                    status: "ACTIVE",
                    type: riderTypeId,
                    provider: providerId,
                  },
                },
              }
            : field
        ),
      };
    }

    return schema;
  }, [t, riderTypeId, providerId]);

  const onSubmit = async ({ values, formMode }) => {
    console.log("onSubmit", values._id);

    try {
      if (!values) return;
      const data = await api.Order.addRider({
        riderValue: values,
        basicPlanOrderId,
      });

      formAction.close();
      const riders = _.get(mainForm.values, "riders");

      data.rider.product = data.rider.productSnapShot;
      riders.push(data.rider);
      mainForm.setFieldValue("riders", [...riders]);

      showNotification({
        title: ` Rider added`,
        message: "Rider added succesfully",
      });
    } catch (error) {
      console.log(error);

      showNotification({
        color: "red",
        icon: <IconExclamationMark size={18} />,
        title: ` Rider add error`,
        message: error.msg ?? error.message,
      });
    }
  };

  const [renderForm, formAction, formStatus, formSetting] = useFormRender(
    formSchema,
    null,
    onSubmit
  );

  const handleActionClick = () => {
    if (!mainForm || !mainForm.values) return;

    const id = mainForm?.values._id;
    if (!id) return;

    const orderProviderId = getOrderProviderId(mainForm.values);
    if (!orderProviderId || !riderTypeId) {
      showNotification({
        color: "red",
        icon: <IconExclamationMark size={18} />,
        title: "Cannot add rider",
        message: !orderProviderId
          ? "Order provider is missing."
          : "Rider product type is not configured.",
      });
      return;
    }

    setBasicPlanOrderId(id);
    const riderValue = _.cloneDeep(mainForm.values);
    if (!riderValue) return;

    riderValue._id = null;
    riderValue.product = null;
    riderValue.productSnapShot = null;
    riderValue.payment = {};
    riderValue.orderRemarks = [];
    formAction.open({ mode: "edit", id, data: riderValue });
  };

  return (
    <>
      <Button fullWidth onClick={() => handleActionClick()}>
        {label}
      </Button>

      {renderForm()}
    </>
  );
};

export default OrderAddRiderActionButton;
